"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParticipantLinkedInShareState = void 0;
var ParticipantLinkedInShareState;
(function (ParticipantLinkedInShareState) {
    ParticipantLinkedInShareState["None"] = "none";
    ParticipantLinkedInShareState["PlayOnce"] = "play-once";
    ParticipantLinkedInShareState["SharedToLinkedin"] = "shared-to-linkedin";
    ParticipantLinkedInShareState["Paid"] = "paid";
})(ParticipantLinkedInShareState = exports.ParticipantLinkedInShareState || (exports.ParticipantLinkedInShareState = {}));
//# sourceMappingURL=linked-in-share-state.js.map